module.exports = __webpack_public_path__ + "static/media/lefthf.6c7c3880.png";